export const form_valueExists = (values, key) => (Object.keys(values).indexOf(key) !== -1) && (values[key] !== '') && (values[key] !== null);

export const hcfLabel = (options, key) => {
    const value = options.find(i => i.value.toString() === key.toString());
    return value ? value.label : '';
}